import React, { useState } from "react";
import { connect } from "react-redux";
import Appbar from "./appbar";
import DemoCarousel from "./carsouel";
import Signbutton from "../forms/button";
import {
    saveEmpanelment,
    empanelmentRegistration,
} from "../../store/actions/empanelment";
const BajajCompanies = (props) => {

    const [options, setOptions] = useState([
        { option: "Bajaj Finance Limited ( as an FD Distributor)", done: false ,value:"BFL"},
        { option: "Bajaj Allianz General Insurance Company (General Insurance Distributor)", done: false,value:"BAG" },
        { option: "Bajaj Allianz Life Insurance Company (Life Insurance Distributor)", done: false,value:"BAL" },
        { option: "Bajaj Financial Securities Limited (Broking & Distribution Partners)", done: false ,value:"BFS"},
        { option: "None of the Above", done: false,value:"NOA" },
    ]);
    const handleChange = (done, i) => {
        let tmp = options[i];
        tmp.done = !done;
        let optionsClone = [...options];
        optionsClone[i] = tmp;
        setOptions([...optionsClone]);
    };
    const submit = async () => {
        const option = options.filter((opt) => opt.done === true && delete opt.done && delete opt.option)
        var result = option.map(function (item) {
            return item['value'];
        });
        const { empanelmentBasicDetails, empanelmentBankDetails } = props;
        const params = {
            ...props.storeempanelmentNomineeDetails,
            bnk_name: empanelmentBankDetails.bnkName,
            bnk_accno: empanelmentBankDetails.bnkAccnum,
            bnk_ifsc: empanelmentBankDetails.ifsc,
            branch: empanelmentBankDetails.bnkBranch,
            bnk_city: empanelmentBankDetails.bnkCity,
            pan: empanelmentBasicDetails.pan,
            email: empanelmentBasicDetails.email,
            mobile: empanelmentBasicDetails.mobile,
            agentcode: empanelmentBasicDetails.arnCode,
            pennydropflag: empanelmentBankDetails.pennydropflag,
            otherentity: result,
        };
        const response = await props.saveEmpanelment(params);
        const { ID } = response.Dtinformation[0];
        const AgentParams = {
            arncode: empanelmentBasicDetails.arnCode,
            pan: empanelmentBasicDetails.pan,
            email: empanelmentBasicDetails.email,
            mobile: empanelmentBasicDetails.mobile,
            bnk_name: empanelmentBankDetails.bnkName,
            bnk_accno: empanelmentBankDetails.bnkAccnum,
            CDSL: empanelmentBankDetails.cdsl,
            NSDL: empanelmentBankDetails.nsdl,
            bnk_ifsc: empanelmentBankDetails.ifsc,
            branch: empanelmentBankDetails.bnkBranch,
            bnk_city: empanelmentBankDetails.bnkCity,
            AMC_Branch: empanelmentBankDetails.AMC_Branch,
            Ihno: ID || "",
            rmname: empanelmentBankDetails.rmname,
            pennydropflag: empanelmentBankDetails.pennydropflag,
        };
        const Agentresponse = await props.empanelmentRegistration(AgentParams);

        if (!!Agentresponse) {
            const data = Agentresponse.Dtinformation[0] || {};
            try {
                if (data.Return_Code == 0) {
                    // const name = props.camsdata[0].ARN_NAME;
                    // const message = `${data.Agent}-${name} - has been registered successfully`;
                    const message = "Your empanelment request has been successfully submitted. You shall receive a confirmation of the empanelment shortly";
                    props.history.push("/distributor-empanellement/confirmation", {
                        message: message,
                    });
                } else {
                    props.history.push("/distributor-empanellement/confirmation", {
                        message: data.Return_Msg,
                    });
                }
            } catch (e) {
                alert(e);
            }
        }
    };
    return (
        <div className="login-container">
            {/* <QueryAssistant /> */}
            <Appbar />
            <div className="login-without-appbar">
                <DemoCarousel />
                <div className="login-right-div" style={{ overflow: "scroll" }}>
                    <div>
                        <div className="bajaj-input-name">Do you wish to associate with any of the following Bajaj Finserv Group Companies?</div>
                        <div className="input-field-container">
                            {options.map(({ option, done }, i) => (
                                <div key={i}>
                                    <label htmlFor={i}>
                                        <input
                                            type="checkbox"
                                            onChange={() => handleChange(done, i)}
                                            checked={done}
                                            id={i}
                                        />
                                        <span style={{ marginLeft: 10 }}>{option}</span>
                                    </label>
                                </div>
                            ))}
                        </div>
                        <div>
                            <p style={{ fontSize:"12px",marginTop: "10px", fontFamily: "Rubik-Italic" }}>
                            Disclaimer - Should you choose to associate with any of the above Group companies, please note that your association is independent of that with BFAML. We will only be sharing your expression of interest with the selected Group company for them to take it forward with you. You will have to take up any query/concern with the concerned group company.
                            </p>
                        </div>
                    </div>
                    <Signbutton buttontitle="Submit" onClick={submit} />
                </div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer }) => {
        const {
            empanelmentData,
            camsdata,
            empanelmentBasicDetails,
            empanelmentBankDetails,
            storeempanelmentNomineeDetails
        } = authReducer;
        return {
            camsdata,
            empanelmentData,
            empanelmentBasicDetails,
            empanelmentBankDetails,
            storeempanelmentNomineeDetails
        };
    },
    {
        saveEmpanelment,
        empanelmentRegistration,
    }
)(BajajCompanies);
